<template>
    <div class="help-warpper flex flex-direction">
        <div class="header-container">
            <div class="header">
                <!--                <router-link to="/home">-->
                <!--                    <img src="../assets/img/logo_emof.png" alt="" class="logo_zc"/>-->
                <!--                </router-link>-->
                <a :href="`${IMAGE_PATH}`">
                    <img v-if="user.morgwlogo" :src="user.morgwlogo" alt="" class="logo_zc"/>
                    <img v-else alt="" class="logo" src="../assets/img/logo_emof.png"/>
                </a>
                <div class="home flex align-center">
                    <div class="service">
                        <i class="iconfont icon-kefu margin-right-xs font-size-lg"></i>客服电话：{{ service_phone }}
                    </div>
                    <div class="operate" @click="goBack">返回</div>
                </div>
            </div>
        </div>
        <div v-loading="loading" class="page-content flex flex-direction  padding-sm flex-sub">
            <div class="page-nav flex align-center justify-between">
                <div class="flex align-center">
                    <div class="page-nav margin-right-xs">您现在的位置：常见问题
                    </div>
                </div>
                <div>欢迎使用会员管理系统！</div>
            </div>
            <div class="page-list flex  flex-sub margin-top-sm">
                <!--                <i class="menu-expand" :class="expand ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="expand = !expand"></i>-->
                <div v-if="expand" class="menu-container flex flex-direction self-start">
                    <div class="menu-type flex align-center margin-bottom-sm">
                        <div v-for="(item,index) in menus" :key="index"
                             :class="{active:item.type === type}" class="menu-type_item flex align-center justify-center" @click="changeTab(item)">
                            <div>{{ item.title }}</div>
                        </div>
                    </div>
                    <empty v-if="lists.length === 0" :type="0" class="self-center"/>
                    <div v-for="(item,index) in infos" :key="index"
                         :class="[{active:cur_index.split('_').slice(1,3).map(Number).indexOf(item.id)!==-1
                          || item.child.some(s=> cur_index.split('_').slice(1,3).map(Number).indexOf(s.id)!==-1)}]"
                         class="menu_item flex flex-direction">
                        <div :class="['level_'+item.level,{active:cur_index.split('_').slice(1,3).map(Number).indexOf(item.id)!==-1
                             || item.child.some(s=> cur_index.split('_').slice(1,3).map(Number).indexOf(s.id)!==-1)}]"
                             class="menu_item-title flex align-center justify-between"
                             @click="menuChange(item,index)">
                            <div class="flex align-center"><i class="tag">{{ item.tag.join('.') }}</i>{{ item.title }}
                            </div>
                            <i v-if="item.child.length" :class="item.expand ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
                        </div>
                        <div v-if="item.expand">
                            <div v-for="(item1,index1) in item.child" :key="index1"
                                 class="flex flex-direction">
                                <div :class="['level_'+item1.level,{active:cur_index.split('_').slice(1,3).map(Number).indexOf(item1.id)!==-1}]"
                                     class="menu_item-title"
                                     @click="contentChange(item1)">
                                    <span>{{ item1.tag.join('.') }} </span>{{ item1.title }}
                                </div>
                                <div v-for="(item2,index2) in item1.child" :key="index2"
                                     class="flex flex-direction">
                                    <div :class="['level_'+item2.level,{active:cur_index.split('_').slice(2,3).map(Number).indexOf(item2.id)!==-1}]"
                                         class="menu_item-title"
                                         @click="contentChange(item2)">
                                        <span>{{ item2.tag.join('.') }} </span>{{ item2.title }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div ref="content" class="help-container flex flex-direction flex-sub">
                    <empty v-if="lists.length === 0" :type="0" class="self-center"/>
                    <div v-if="lists.length" class="flex flex-direction flex-sub">
                        <div v-for="(item,index) in lists" :key="index"
                             class="help-item flex flex-direction margin-bottom-xs">
                            <div :ref="`${item.level}_${item.pid}_${item.id}`" :class="'level_'+item.level"
                                 class="item-title" @click="contentChange(item)">
                                {{ item.tag.join('.') }}.{{ item.title }}
                            </div>
                            <div class="help-detail margin-top-xs" v-html="item.content"></div>
                        </div>
                        <el-divider></el-divider>
                        <div v-if="infos.length" :class="cur_position === 0 ? 'justify-end' : ' justify-between '" class="flex align-center">
                            <div v-if="cur_position !== 0" class="page-number  flex" @click="menuChange(infos[cur_position -1],cur_position -1)">
                                <div class="tag"><i class="el-icon-arrow-left"></i>上一节</div>
                                <div class="title margin-left-xs"> {{ infos[cur_position - 1].tag.join('.')
                                    }}.{{ infos[cur_position - 1].title }}
                                </div>
                            </div>
                            <div v-if="cur_position !== infos.length - 1" class="page-number next flex" @click="menuChange(infos[cur_position +1],cur_position +1)">
                                <div class="tag">下一节</div>
                                <div class="title margin-left-xs"> {{ infos[cur_position + 1].tag.join('.')
                                    }}.{{ infos[cur_position + 1].title }}
                                    <i class="el-icon-arrow-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-button v-if="top" circle class="back_top" type="primary" @click="scrollTop"><i class="el-icon-top"></i>
            </el-button>
        </div>
    </div>
</template>

<script>
import {getHelpList} from "@/api/member";
import {service_phone} from "@/utils/const";
import {IMAGE_PATH} from "@/config";

export default {
    name: "help",
    data() {
        return {
            IMAGE_PATH: IMAGE_PATH,
            service_phone: service_phone,
            menus: [{
                title: '电脑端',
                type: 1
            },
                //     {
                //     title: '分支机构端',
                //     type: 12
                // },
                {
                    title: '手机端',
                    type: 2
                }],
            type: 1,
            elements: [],
            infos: [],
            lists: [],
            cur_index: '',
            cur_position: 0,
            expand: true,
            top: false,
            loading: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.cur_index = this.$route.query.tag
        this.cur_position = Number(this.$route.query.pos || 0)
        this.init()
    },
    components: {},
    methods: {
        goBack() {
            if (window.history.length) {
                window.history.go(-1)
            } else {
                window.location.href = `${IMAGE_PATH}`
            }
        },
        changeTab(data) {
            this.type = data.type
            this.init()
        },
        //  页面加载时请求
        async init() {
            this.loading = true
            let _data = await getHelpList(this.user.type, this.type)
            this.loading = false
            this.infos = _data.data
            this.format_info(this.infos, 1)

            let info = this.infos[this.cur_position];
            this.setInfoContent(info);

            this.$nextTick(() => {
                let nodes = document.getElementsByClassName('help-item')
                for (let i = 0; i < nodes.length; i++) {
                    this.elements.push({
                        index: i,
                        offsetTop: nodes[i].offsetTop + 20
                    })
                }
            })
        },
        format_info(list, level, tag = []) {
            list.map((item, index) => {
                let _tag = this.getLevel(level, index);
                item.tag = [...tag, ..._tag]
                item.expand = index === this.cur_position
                item.level = level
                if (item.child && item.child.length) {
                    this.format_info(item.child, level + 1, item.tag)
                }
            })
        },
        setInfoContent(info) {
            this.lists = []
            this.setItem(info)
            this.format_data(info)
            this.$nextTick(() => {

                setTimeout(() => {
                    let nodes = document.getElementsByClassName('help-item')
                    this.elements = []
                    for (let i = 0; i < nodes.length; i++) {
                        this.elements.push({
                            index: i,
                            offsetTop: nodes[i].offsetTop - 250
                        })
                    }
                    if (this.cur_index) {
                        this.$refs[this.cur_index][0].scrollIntoView({
                            block: 'start', // 当前元素显示在视图区域中间
                            behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
                        })
                    } else {
                        let item = this.lists[0];
                        this.cur_index = `${item.level}_${item.pid}_${item.id}`;

                    }
                }, 1000)
            })

        },
        setItem(item) {
            this.lists.push({
                id: item.id,
                title: item.title,
                content: item.content,
                pid: item.pid,
                tag: item.tag,
                level: item.level,
            })
        },
        format_data(data) {
            data.child.map(item => {
                this.setItem(item);
                if (item.child && item.child.length) {
                    this.format_data(item)
                }
            });
        },

        getLevel(level, position) {
            if (level === 3) {
                return [position];
            } else {
                return [position + 1];
            }
        },
        menuChange(item, index) {
            if (this.cur_position === index) {
                this.infos[index].expand = !this.infos[index].expand
                this.$forceUpdate()
                return
            }
            this.expandStatus(item);
            this.setInfoContent(item);
            this.cur_position = index
            this.cur_index = `${item.level}_${item.pid}_${item.id}`
            this.$nextTick(() => {
                this.$refs[this.cur_index][0].scrollIntoView({
                    block: 'start', // 当前元素显示在视图区域中间
                    behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
                })
            })
        },
        expandStatus(data) {
            this.infos.map((item) => {
                item.expand = data.tag[0] === item.tag[0]
            })
        },
        contentChange(item) {
            this.cur_index = `${item.level}_${item.pid}_${item.id}`
            this.$nextTick(() => {
                this.$refs[this.cur_index][0].scrollIntoView({
                    block: 'start', // 当前元素显示在视图区域中间
                    behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
                })
            })
        },
        scrollTop() {
            this.$refs.content.scrollTo({
                top: '0',
                left: '0',
                behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
            })
        }
    },
    mounted() {
        document.getElementsByClassName('help-container')[0].addEventListener('scroll', () => {
            let offsetHeight = document.getElementsByClassName('help-container')[0].scrollTop;
            this.top = offsetHeight > 100
            let find = this.elements.find((item, index) => {
                if (index === this.elements.length - 1) {
                    return offsetHeight >= item.offsetTop
                }
                return offsetHeight >= item.offsetTop && offsetHeight < this.elements[index + 1].offsetTop;
            });
            if (find) {
                let item = this.lists[find.index];
                this.cur_index = `${item.level}_${item.pid}_${item.id}`
            }
        })
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>

.help-warpper {
    height: 100vh;
    background: #FFFFFF;

    .menu-type {
        background-color: #f1f1f1;
        border-radius: 10px;

        .menu-type_item {
            height: 40px;
            font-size: 14px;
            color: #666666;
            padding: 0 10px;
            text-align: center;
            cursor: pointer;
            flex-shrink: 0;
            flex-grow: 1;

            .span {
                font-weight: 600;
            }

            &.active {
                background-color: #ff9600;
                border-radius: 10px;
                color: #FFFFFF;
                //position: relative;
                //
                //&:before {
                //    position: absolute;
                //    bottom: -8px;
                //    border-left: 8px solid transparent;
                //    border-top: 8px solid #ee9900;
                //    border-right: 8px solid transparent;
                //    left: 50%;
                //    transform: translateX(-50%);
                //    content: '';
                //}
            }
        }

        //.menu-type_item + .menu-type_item {
        //    border-left: 1px solid #ffffff;
        //}
    }

    .page-number {
        height: 36px;
        line-height: 36px;
        //background-color: #f3f7fb;
        border-radius: 18px;
        color: #0a2240;
        cursor: pointer;
        font-size: 14px;
        position: relative;

        &:after {
            position: absolute;
            height: 1px;
            left: 16px;
            right: 0;
            background-color: #0a2240;
            border-radius: 1px;
            content: '';
            bottom: 0;
        }

        &.next {
            &:after {
                right: 16px;
                left: 0;
            }
        }

    }

    .menu-expand {
        position: fixed;
        bottom: 10px;
        left: 10px;
        color: #ee9900;
        font-size: 20px;
        cursor: pointer;
    }

    .back_top {
        position: fixed;
        bottom: 200px;
        right: 150px;
    }

    .page-content {
        width: 1200px;
        margin: 0 auto;
        overflow: hidden;

        .page-nav {
            font-size: 16px;
            color: #0a2240;
        }

        .page-list {
            overflow: hidden;

            .help-container {
                background-color: #fafafa;
                border-radius: 10px;
                margin-left: 18px;
                padding: 30px 16px;

                &::-webkit-scrollbar {
                    width: 6px;
                    height: 10px;
                    /*background-image: var(--gradualRed);*/
                }

                &::-webkit-scrollbar-track {
                    border-radius: 10px;
                    background-color: #fafafa;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    width: 5px;
                    height: 10px;
                    background: #999999;
                }

                overflow: auto;
                //padding: 30px;

                .help-item {
                    .item-title {
                        cursor: pointer;

                        &:hover {
                            text-decoration: underline #ee9900;
                        }

                        &.level_1 {
                            font-size: 22px;
                            font-weight: 600;
                            line-height: 34px;
                            color: #0a2240;
                        }

                        &.level_2 {
                            font-size: 16px;
                            line-height: 28px;
                            color: #0a2240;
                        }

                        &.level_3 {
                            font-size: 1.25rem;
                            margin: 40px 0;
                        }

                        &.level_4 {
                            font-size: 12px;
                        }
                    }

                }
            }

            .menu-container {
                position: relative;
                width: 250px;
                left: 0;
                top: 0;
                height: 100%;
                overflow-y: auto;
                padding: 20px 10px;
                //border-right: 1px solid #eeeeee;
                //border-left: 1px solid #eeeeee;
                background-color: #fafafa;
                border-radius: 10px;

                &::-webkit-scrollbar {
                    width: 3px;
                    height: 10px;
                    /*background-image: var(--gradualRed);*/
                }

                &::-webkit-scrollbar-track {
                    border-radius: 10px;
                    background-color: #fff;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    width: 5px;
                    height: 0px;
                    background: #99999988;
                }

                //&:before {
                //    background-color: #dee0e3;
                //    content: " ";
                //    display: block;
                //    height: 100%;
                //    right: 0;
                //    position: absolute;
                //    width: 1px;
                //}

                .menu_item {

                    padding: 10px 12px;

                    &.active {
                        background-color: #ededed;
                        border-radius: 10px;
                    }

                    .menu_item-title {
                        cursor: pointer;
                        color: #666666;
                        font-size: 14px;
                        overflow: hidden;
                        text-decoration: none;
                        text-overflow: ellipsis;
                        white-space: nowrap;

                        &.active {
                            &.level_1 {
                                font-size: 16px;
                                color: #ff9600;

                                .tag {
                                    background-color: #ff9600;
                                    color: #FFFFFF;
                                }
                            }

                            &.level_2 {
                                color: #ff9600;
                            }
                        }

                        &:hover, &.active {
                            color: #ff9600;
                        }

                        span {
                            margin: 0 2px;
                        }

                        &.level_1 {
                            font-size: 16px;
                            color: #666666;

                            .tag {
                                display: inline-block;
                                width: 20px;
                                height: 20px;
                                border-radius: 20px;
                                margin-right: 12px;
                                text-align: center;
                                line-height: 20px;
                                background-color: #f1f1f1;
                                font-size: 12px;
                                color: #94a2b4;
                            }
                        }

                        &.level_2 {
                            padding-left: 32px;
                            margin-top: 20px;
                        }

                        &.level_3 {
                            padding-left: 46px;
                            margin-top: 20px;
                        }

                        &.level_4 {
                            padding-left: 30px;
                        }
                    }

                }
            }

        }
    }
}

.header-container {
    background-color: #0a2240;
    box-shadow: 0px 6px 18px 1px rgba(10, 34, 64, 0.45);
    width: 100%;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        height: 100px;
        margin: 0 auto;

        .logo_zc {
            height: 52px;
        }

        .logo {
            height: 42px;
        }

        .title {
            font-size: 24px;
            font-weight: bold;
            color: #ffffff;
            margin-left: 20px;
        }

        .home {
            .service {
                font-size: 18px;
                color: #f5f5f5;
                margin-right: 20px;
            }

            .operate {
                padding: 0 20px;
                height: 40px;
                background-color: #ff9600;
                border-radius: 20px;
                font-size: 16px;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                user-select: none;
            }
        }
    }
}
</style>